import { render } from "./ViewDataBerasa.vue?vue&type=template&id=6f03aa2f"
import script from "./ViewDataBerasa.vue?vue&type=script&lang=js"
export * from "./ViewDataBerasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__